<template lang="pug">
  .prepaid-process.mx-auto
    //- .overlay(v-show="overlay")
    v-dialog(v-model="modalPrepaymentConditions", max-width="380px", persistent)
      v-card.pt-4.px-3.pb-5
        v-card-text.modal-prepayment-conditions
          h3.text-xs-center.mt-2.text-blue.font-weight-bold Condiciones del prepago.
          ul
            li.g-flex
              p.mr-2 1.
              p El prepago se realizará en la moneda de la renta contratada.
            li.g-flex
              p.mr-2 2.
              p El monto mínimo del prepago es el 10% de la deuda.
            li
              .g-flex
                p.mr-2 3.
                p Los prepagos serán aplicados de la siguiente manera:
              ul
                li.g-flex
                  p.mr-2 3.1
                  p Si realiza un prepago total en cualquier fecha será, el pago se verá reflejado al mes siguiente.
                li.g-flex
                  p.mr-2 3.2
                  p Si realiza un prepago parcial dentro del día 8 de cada mes, el pago se verá reflejado al mes siguiente.
                li.g-flex
                  p.mr-2 3.3
                  p Si realiza un prepago parcial fuera del día 8 de cada mes, su prepago parcial se verá reflejado en el mes subsiguiente.
            li.g-flex
              p.mr-2 4.
              p Se enviará un nuevo cronograma según la naturaleza del prepago (total o parcial).
          v-layout.mt-4
            v-btn(@click="modalPrepaymentConditions = false").btn-purple.mx-auto.px-5 Confirmar

    v-dialog(v-model="modalProcess", max-width="380px", persistent)
      v-card.pt-4.px-3.pb-5
        v-card-text.modal-process
          h2.text-xs-center Resumen
          .modal-process-rect.text-xs-center.py-3
            svg(width="29" height="34" viewBox="0 0 29 34" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M14.3124 33.4535C14.1339 33.4535 13.9566 33.4244 13.7875 33.3672C5.53257 30.6707 0.000513929 22.7418 0.000513929 13.6551V7.61255C-0.0123382 6.88784 0.216181 6.17942 0.650108 5.59883C1.08404 5.01823 1.69873 4.59843 2.39741 4.4055L14.31 0L26.225 4.4055C26.9264 4.59574 27.5443 5.0144 27.981 5.59524C28.4177 6.17608 28.6483 6.88595 28.6363 7.61255V13.6551C28.6363 22.749 23.0923 30.6731 14.8373 33.3672C14.6681 33.424 14.4909 33.4531 14.3124 33.4535ZM14.3124 2.30102L3.0302 6.47163L2.96788 6.48601C2.72512 6.5557 2.51251 6.70428 2.36362 6.90829C2.21474 7.1123 2.13807 7.36011 2.14574 7.61255V13.6551C2.14574 21.7591 7.02823 28.8179 14.3124 31.27C21.599 28.8179 26.4815 21.7591 26.4815 13.6551V7.61255C26.4891 7.36011 26.4125 7.1123 26.2636 6.90829C26.1147 6.70428 25.9021 6.5557 25.6593 6.48601L25.5347 6.44766L14.3124 2.30102Z" fill="#0855C4")
              path(d="M12.0017 20.5821L7.51953 16.3731L8.99841 14.8007L12.0521 17.6698L20.4149 10.3545L21.8362 11.9772L12.0017 20.5821Z" fill="#0855C4")

            p.mt-2.text-blue.font-weight-bold Tu orden ha sido generada
            .g-flex.mt-2.g-justify-center
              p.font-weight-bold.mr-1 Por el monto:
              p.font-weight-bold {{ txtNumberLoad }}
          v-layout.px-4.mt-3.text-semiblue
            v-flex(xs6)
              p Cuenta :
            v-flex(xs6).text-xs-right
              p Interseguro
          v-layout.px-4.mt-1.text-semiblue
            v-flex(xs6)
              p Servicio :
            v-flex(xs6).text-xs-right
              p(v-if="(paramsPrepagos.moneda || {}).nombre == 'SOLES'") PAGOPOLIZA MN
              p(v-else) PAGOPOLIZA ME
          v-layout.px-4.mt-1.text-semiblue
            v-flex(xs6)
              p N° de  póliza:
            v-flex(xs6).text-xs-right
              p {{ numeroPoliza }}
          .mt-3.text-xs-center.text-semiblue
            p Tiempo de expiración:
            p.font-weight-bold Válido solo el {{ currentDate }} hasta las 11:59 p.m
          //- p.text-xs-center.color-skyblue.mt-3.font-weight-medium Tómale una foto o descarga el resumen  para mostrar los datos en el banco.
          p.text-xs-center.color-skyblue.mt-3.font-weight-medium Tómale una foto para mostrar los datos en el banco.
          v-layout.mt-4
            v-btn(@click="goToHome()").btn-entendido.btn-purple.mx-auto Entendido
          //- .text-xs-center.mt-3
            a.text-blue.font-weight-bold Descargar resumen
          //- h4.font-weight-bold.mt-2.text-blue.text-xs-center Enviar mi resumen de solicitud al:
          //- .g-flex.mt-2.g-justify-center
            figure.mr-2
              img(src="./../../assets/loans/whatsapp.svg")
            //figure
              img(src="./../../assets/loans/email.svg")

    v-container
      .prepaid-process-header
        v-layout
          .circle.circle-line.transition-all-3(:class="{'circle-active': activeCircle1}")
            v-icon check
          .circle.circle-line.transition-all-3(:class="{'circle-active': activeCircle2}")
            p(v-show="step2HeaderText") 2
            v-icon(v-show="step2HeaderCheck") check

          .circle.transition-all-3(:class="{'circle-active': activeCircle3}")
            p(v-show="step3HeaderText") 3
            v-icon(v-show="step3HeaderCheck") check

        h2.text-xs-center {{titleProcess}}
      .prepaid-process-main
        .prepaid-process-main-item(v-show="step1Content")
          .mt-3
            v-layout(wrap)
              v-flex(md6).mt-3.w-full-m.prepaid-process-one
                article.pb-5.px-3.border-2-gray-light.pt-1
                  .mt-4
                    p Producto
                    h3.font-weight-bold {{ nombreProducto }}
                  v-layout(align-center).mt-3.prepaid-process-one-row-icon
                    v-flex(md9)
                      .g-flex
                        figure
                          img(src="./../../assets/iconsv5/icon-moneda.svg")
                        p Saldo actual del capital
                    v-flex
                      p.font-weight-bold.text-xs-right
                        | {{ general.saldoActualCapital }}
                  v-layout.mt-3.prepaid-process-one-row-icon
                    v-flex
                      .g-flex
                        figure
                          img(src="./../../assets/iconsv5/icon-calendar.svg")
                        p Nº de cuotas pendientes
                    v-flex(md5)
                      p.font-weight-bold.text-xs-right {{ general.cuotasPendientes }}
                  v-layout.mt-3.prepaid-process-one-row-icon
                    v-flex
                      .g-flex
                        figure
                          img(src="./../../assets/iconsv5/icon-calendar.svg")

                        p Monto de cuota actual
                    v-flex(md5)
                      p.font-weight-bold.text-xs-right
                        | {{ general.montoCuotaActual }}
                  .prepaid-process-one-date.mt-3
                    .g-flex
                      p Inicio de pago:&nbsp;
                      p {{ general.fechaInicioDePago }}
                    span -
                    .g-flex
                      p Fin de pago:&nbsp;
                      p {{ general.fechaFinDePago }}

                  h3.mt-5.text-blue.font-weight-bold Simula tu prepago
                  p.mt-2 Ingresa el monto a prepagar
                  .input-text
                    input(type="tel", v-model="txtNumberLoad", v-on:keypress="verifyChars($event)", @keyup.delete="clearAmountField", @keyup.enter="makeQuote(txtNumberLoad)", @blur="makeQuote(txtNumberLoad)", :placeholder="placeholderAmountPP").border-2-gray-light
                  .mt-1
                    p.text-sky El monto mínimo de prepago es de {{ montoMinimoPrepago }} (10% de deuda)
              v-flex.mt-2.prepaid-process-two(md6  v-show="step1ShowColumnTwo").w-full-m
                article
                  h3.text-blue.font-weight-bold Nueva deuda total del préstamo
                  p.font-weight-bold.mt-1 Elige la opción que más se acomode a tus necesidades
                  .mt-3(v-for="item in dataTableLoad", :key="item.id")
                    .style-table.transition-all-3.cursor-pointer(:class="{'border-2-gray-light': item.inactive, 'border-2-blue': item.active}", @click="activeTableLoad(item)")
                      v-layout(style="position:relative" align-center, :class="{'bg-gray-light': item.inactive, 'bg-blue': item.active}")
                        v-flex(xs1 style="position:absolute").ml-2.mr-2
                          .style-table-circle(:class="{'bg-gray-light': item.inactive, 'bg-blue': item.active}")
                            v-icon(v-show="item.check") check
                        v-flex(xs11).text-xs-center.pt-1
                          p.white--text Opción: {{item.option}}
                          div(v-html="item.name")
                      .px-3.pb-1
                        v-layout(align-center).py-2.line-gray-light.prepaid-process-two-row
                          v-flex(xs8)
                            p(:class="{'font-weight-bold': item.activeMonto}") Nuevo monto de cuota
                          v-flex(xs4 md3)
                            .g-flex.g-justify-center(:class="{'font-weight-bold': item.activeMonto, 'active-bg-blue': item.activeBackBlue}")
                              p {{item.moneyCout}}
                        v-layout(align-center).py-2.line-gray-light.prepaid-process-two-row
                          v-flex(xs8)
                            p(:class="{'font-weight-bold': item.activeCuota}") Nuevo N° de cuotas pendientes:
                          v-flex(xs4 md3).text-xs-center
                            p(:class="{'font-weight-bold': item.activeCuota, 'active-bg-gray': item.activeBackGray}")
                              | {{item.numberCout}}
                        v-layout(align-center).py-2.prepaid-process-two-row
                          v-flex(xs8)
                            //- p Saldo capital:
                            p Devolución final:
                          v-flex(xs4 md3).text-xs-center
                            p {{item.numberCapital}}
                  p.text-xs-center.mt-3
                    | Al continuar, acepto las&nbsp;
                    a.font-weight-bold.text-blue(@click="modalPrepaymentConditions = true") Condiciones del prepago
                    | .
                  v-layout.mt-3
                    v-btn(@click="viewStep2").btn-purple.mx-auto.px-5 Confirmar
                  .mt-3.text-xs-center
                    h4.font-weight-bold(@click="hasAnotherSimulation()").btn-text-blue Volver a simular
        .prepaid-process-main-item(v-show="step2Content")
          .prepaid-process-step-2.mt-4
            article.border-2-gray-light.cursor-pointer.mt-4.mx-auto.px-2.py-3.efect-scale(@click="viewStep3('banco')")
              v-layout(align-center)
                v-flex(xs2).text-xs-center
                  img(src="./../../assets/loans/icons/bank.svg" width="40px")
                v-flex(xs9)
                  p.pl-2.font-weight-bold Me acercaré a un banco
                v-flex(xs1)
                  v-icon navigate_next
            article.border-2-gray-light.cursor-pointer.mt-4.mx-auto.px-2.py-3.efect-scale(@click="viewStep3('transferencia')")
              v-layout(align-center)
                v-flex(xs2).text-xs-center
                  figure
                    img(src="./../../assets/loans/icons/number-account.svg" width="40px")
                v-flex(xs9)
                  p.px-2.font-weight-bold Haré transferencia en banca por Internet o app de mi banco
                v-flex(xs1)
                  v-icon navigate_next
            .prepaid-process-step-2-remenber
              .g-flex
                svg(width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg")
                  path(d="M7.30019 9.54178H7.39987C7.56186 9.54178 7.58678 9.42964 7.59924 9.24273L7.87338 4.1339C7.88584 3.76008 7.73631 3.64794 7.51202 3.64794H7.20051C6.97622 3.64794 6.82669 3.76008 6.83915 4.1339L7.11328 9.24273C7.12574 9.42964 7.15066 9.54178 7.30019 9.54178ZM7.28773 11.8345H7.41234C7.77369 11.8345 7.97306 11.6352 7.97306 11.2863V11.1617C7.97306 10.8128 7.77369 10.6009 7.41234 10.6009H7.28773C6.93883 10.6009 6.73946 10.8128 6.73946 11.1617V11.2863C6.73946 11.6352 6.93883 11.8345 7.28773 11.8345Z" fill="#454A6C")
                  circle(cx="7.47634" cy="7.47634" r="6.85331" stroke="#454A6C" stroke-width="1.24606")
                p Recuerda el monto máximo diario a transferir permitido por tu banca online.
        .prepaid-process-main-item(v-show="step3Content")
          .prepaid-process-step-3.mt-4
            .mx-auto
              .prepaid-process-step-3-list.g-flex.g-flex-wrap
                article
                  .prepaid-process-step-3-item-title
                    .circle-blue.mx-auto
                      span 1
                    v-layout.g-flex-wrap.g-align-center.px-3
                      //v-flex(xs6)
                        figure(style="margin-top: -5px;")
                          img(src='./../../assets/icons-prepagos/news/icon-interbank.png', alt='logo de interbank').text-xs-center
                      v-flex(xs6)
                        figure
                          img(src='./../../assets/icons-prepagos/news/icon-scotiabank.png', alt='logo de scotiabank').text-xs-center
                      v-flex(xs6)
                        figure
                          img(src='./../../assets/icons-prepagos/news/icon-bcp.png', alt='logo de bcp').text-xs-center
                      v-flex(xs6)
                        figure
                          img(src="./../../assets/icons-prepagos/news/icon-bbva.png", alt="logo de BBVA").text-xs-center
                    //.g-flex.g-flex-wrap.g-align-center.px-3
                      figure.mt-1.mr-2
                        img(src='./../../assets/icons-prepagos/news/icon-interbank.png', alt='logo de interbank')
                      figure.mt-1.mr-2
                        img(src='./../../assets/icons-prepagos/news/icon-scotiabank.png', alt='logo de scotiabank')
                      figure.mt-1.mr-2
                        img(src='./../../assets/icons-prepagos/news/icon-bcp.png', alt='logo de bcp')
                      figure.mt-1
                        img(src="./../../assets/icons-prepagos/news/icon-bbva.png", alt="logo de BBVA")
                  .prepaid-process-step-3-item-content
                    p.px-3(v-if="typeOfDeposit=='banco'") Genera tu orden de prepago y dirígete a cualquiera de estos bancos.
                    p.px-3(v-else) Genera tu orden de prepago e ingresa a tu app/banca por internet de cualquiera de estos bancos.
                article
                  .prepaid-process-step-3-item-title
                    .circle-blue.mx-auto
                      span 2
                    svg(width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg")
                      g(clip-path="url(#clip0)")
                        path(d="M39.9997 34.5887L37.9622 33.368C37.3411 32.9965 36.6306 32.8004 35.9067 32.8H32.8403C32.2126 32.7988 31.5876 32.8797 30.9806 33.0398L21.7415 35.5199C20.7313 35.7988 19.92 36.5512 19.5661 37.5375L11.4395 33.141C10.7806 32.766 10.0091 32.6387 9.26454 32.7816C8.98368 32.8313 8.71142 32.9207 8.45556 33.0473C7.87782 33.3238 7.39853 33.7707 7.08134 34.3273C6.804 34.8121 6.65829 35.3609 6.65829 35.9191C6.6497 37.059 7.25361 38.1152 8.23954 38.6863L22.8044 47.4008C23.4372 47.7926 24.1661 48 24.9102 48H36.1821C36.6856 48.0004 37.1845 47.9051 37.6524 47.7199L39.9997 46.793V48H47.9997V32H39.9997V34.5887ZM37.0645 46.232C36.7845 46.3426 36.4856 46.3996 36.1845 46.4H24.9102C24.4595 46.3996 24.0177 46.2727 23.6356 46.0336L9.05087 37.309C8.55517 37.0227 8.25165 36.4922 8.25556 35.9199C8.25673 35.6395 8.33056 35.3637 8.47001 35.1199C8.62939 34.8438 8.86923 34.6223 9.15712 34.4855C9.28408 34.4238 9.41845 34.3801 9.55712 34.3559C9.65829 34.3371 9.76103 34.3273 9.86376 34.3273C10.1388 34.3266 10.4091 34.3984 10.6477 34.5352L19.4599 39.2969C19.47 39.3457 19.47 39.3938 19.4829 39.4426C19.8618 40.8391 21.1286 41.809 22.5759 41.8105C23.0212 41.7699 23.4622 41.691 23.8942 41.5754L32.2059 39.3512L31.7934 37.8055L23.5087 40.0199C23.1438 40.1039 22.6731 40.2 22.5759 40.2082C21.8532 40.2094 21.2196 39.7266 21.0294 39.0297C21.0036 38.9328 20.9884 38.8336 20.9829 38.7336C20.9829 38.7336 20.9767 38.5398 20.9829 38.4719C21.0438 37.8027 21.5126 37.241 22.1599 37.0609L31.395 34.5902C31.8665 34.4641 32.3524 34.4 32.8403 34.4H35.9067C36.3411 34.4 36.7673 34.518 37.1395 34.741L39.9997 36.4535V45.0719L37.0645 46.232ZM41.5997 33.6H46.3997V46.4H41.5997V33.6Z" fill="#0855C4")
                        path(d="M32.9953 6.40003L28.7039 2.10901C27.3566 0.753935 25.5234 -0.00543942 23.6129 2.93345e-05H13.5551C12.9344 0.000810584 12.3223 0.145732 11.7664 0.422295L9.97344 1.31917C9.61406 1.50003 9.21484 1.58636 8.81289 1.57034L8 1.54183V2.93345e-05H0V17.6H8V15.2H9.36016L9.84414 15.5199C11.1984 16.4192 12.7754 16.927 14.4 16.9864V27.2H48V6.40003H32.9953ZM6.4 16H1.6V1.60003H6.4V16ZM10.7297 14.1887L9.83984 13.6H8V3.14261L8.7543 3.16956C9.42422 3.19339 10.0891 3.04925 10.6887 2.75042L12.4801 1.85354C12.8137 1.68675 13.182 1.60003 13.5551 1.60003H23.6129C25.0988 1.59573 26.525 2.18636 27.5727 3.23987L30.7328 6.40003H24.1313L22.1895 4.45862L21.0586 5.58948L26.7098 11.241C27.3375 11.866 27.3395 12.8817 26.7145 13.5098C26.0891 14.1375 25.0734 14.1395 24.4457 13.5145L19.7258 8.79456L19.1656 9.27464C17.6191 10.5879 15.3586 10.6215 13.7734 9.35433L13.3098 8.97854L12.3016 10.2215L12.7703 10.6016C13.2605 10.9934 13.8109 11.3035 14.4 11.5199V15.3856C13.0906 15.3274 11.8215 14.9137 10.7297 14.1887ZM22.1098 13.4399L23.3168 14.6473C24.5699 15.8817 26.5816 15.8836 27.8367 14.6512C26.6625 16.4696 27.1258 18.8895 28.8887 20.1453C30.6516 21.4012 33.0902 21.0485 34.425 19.3449C35.7598 17.641 35.5187 15.1887 33.8773 13.7778C32.2363 12.3668 29.7754 12.4961 28.2914 14.0711C28.8379 13.2129 28.9355 12.1434 28.5535 11.2H39.2664C39.6105 13.2129 41.1871 14.7895 43.2 15.1336V18.4664C41.1871 18.8106 39.6105 20.3871 39.2664 22.4H23.1336C22.7895 20.3871 21.2129 18.8106 19.2 18.4664V15.1336C20.3434 14.941 21.3773 14.3391 22.1098 13.4399ZM28.8 16.8C28.8 15.4746 29.8746 14.4 31.2 14.4C32.5254 14.4 33.6 15.4746 33.6 16.8C33.6 18.1254 32.5254 19.2 31.2 19.2C29.8746 19.2 28.8 18.1254 28.8 16.8ZM46.4 25.6H16V11.8551C17.2684 11.9504 18.5328 11.627 19.6 10.9352L20.9648 12.3C20.3645 13.1157 19.4129 13.5981 18.4 13.6H17.6V20H18.4C20.1672 20 21.6 21.4328 21.6 23.2V24H40.8V23.2C40.8 21.4328 42.2328 20 44 20H44.8V13.6H44C42.2328 13.6 40.8 12.1672 40.8 10.4V9.60003H27.3313L25.7313 8.00003H46.4V25.6Z" fill="#0855C4")
                      defs
                        clipPath(id="clip0")
                          rect(width="48" height="48" fill="white")
                  .prepaid-process-step-3-item-content
                    p.px-3(v-if="typeOfDeposit=='banco'") Indica que realizarás el pago en la cuenta de Interseguro:
                    p.px-3(v-else) Selecciona la opción Pago de servicios, luego escribe Interseguro y selecciona la opción:
                    .text-xs-center
                      p.prepaid-process-step-3-text-number.mt-2 Pagopoliza ME
                    p(v-if="typeOfDeposit=='banco'") *No abonar a la cuenta de préstamos
                article
                  .prepaid-process-step-3-item-title
                    .circle-blue.mx-auto
                      span 3
                    p.prepaid-process-step-3-text-number.mt-2 {{ numeroPoliza }}
                  .prepaid-process-step-3-item-content
                    p.px-3(v-if="typeOfDeposit=='banco'") Este es tu número de póliza, indicala al momento de pagar.
                    p.px-3(v-else) Este es tu número de póliza, que debes ingresar.
                article
                  .prepaid-process-step-3-item-title
                    .circle-blue.mx-auto
                      span 4
                    svg(width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M43.5576 3.39648H38.7383V0.688477C38.7383 0.308162 38.4301 0 38.0498 0H8.9502C8.56997 0 8.26172 0.308162 8.26172 0.688477V3.39648H3.44238C1.54421 3.39648 0 4.94069 0 6.83887V37.1318C0 39.03 1.54421 40.5742 3.44238 40.5742H18.1351L17.3065 43.4744C16.9737 44.6391 15.6693 45.623 14.458 45.623H9.27148C8.89126 45.623 8.58301 45.9312 8.58301 46.3115C8.58301 46.6918 8.89126 47 9.27148 47H37.7285C38.1088 47 38.417 46.6918 38.417 46.3115C38.417 45.9312 38.1088 45.623 37.7285 45.623H32.542C31.3307 45.623 30.0263 44.6391 29.6935 43.4744L28.8649 40.5742H43.5576C45.4558 40.5742 47 39.03 47 37.1318V6.83887C47 4.94069 45.4558 3.39648 43.5576 3.39648ZM9.63867 4.13453L17.6265 10.6484L9.63867 17.1623V4.13453ZM10.4049 18.3143L18.7158 11.5368L20.4543 12.9545C21.3366 13.6741 22.4184 14.0339 23.5 14.0339C24.5816 14.0339 25.6633 13.6741 26.5458 12.9545L28.2842 11.5368L36.5967 18.3155C37.0826 18.7095 37.3613 19.2942 37.3613 19.9199H9.63867C9.63867 19.2943 9.91737 18.7095 10.4049 18.3143ZM37.3613 17.1623L29.3735 10.6484L37.3613 4.13444V17.1623ZM37.3613 1.37695C37.3613 2.00255 37.0826 2.58739 36.595 2.98257L25.6755 11.8873C24.415 12.9153 22.5851 12.9155 21.3245 11.8873L10.4034 2.98129C9.91737 2.58739 9.63867 2.00255 9.63867 1.37695H37.3613ZM3.44238 4.77344H8.26172V6.15039H3.44238C3.06216 6.15039 2.75391 6.45855 2.75391 6.83887V16.4775C2.75391 16.8579 3.06216 17.166 3.44238 17.166C3.82261 17.166 4.13086 16.8579 4.13086 16.4775V7.52734H8.26172V20.6084C8.26172 20.9887 8.56997 21.2969 8.9502 21.2969H38.0498C38.4301 21.2969 38.7383 20.9887 38.7383 20.6084V7.52734H42.8691V28.1816H4.13086V19.2314C4.13086 18.8511 3.82261 18.543 3.44238 18.543C3.06216 18.543 2.75391 18.8511 2.75391 19.2314V28.8701C2.75391 29.2504 3.06216 29.5586 3.44238 29.5586H43.5576C43.9379 29.5586 44.2461 29.2504 44.2461 28.8701V6.83887C44.2461 6.45855 43.9379 6.15039 43.5576 6.15039H38.7383V4.77344H43.5576C44.6964 4.77344 45.623 5.70004 45.623 6.83887V30.9355H1.37695V6.83887C1.37695 5.70004 2.30346 4.77344 3.44238 4.77344ZM28.3695 43.8527C28.5585 44.5141 28.934 45.1217 29.4263 45.623H17.5737C18.066 45.1217 18.4415 44.514 18.6305 43.8527L19.5671 40.5742H27.4329L28.3695 43.8527ZM43.5576 39.1973H3.44238C2.30346 39.1973 1.37695 38.2707 1.37695 37.1318V32.3125H45.623V37.1318C45.623 38.2707 44.6964 39.1973 43.5576 39.1973Z" fill="#0855C4")
                      path(d="M23.5 33.6895C22.3611 33.6895 21.4346 34.6161 21.4346 35.7549C21.4346 36.8937 22.3611 37.8203 23.5 37.8203C24.6388 37.8203 25.5654 36.8937 25.5654 35.7549C25.5654 34.6161 24.6388 33.6895 23.5 33.6895ZM23.5 36.4434C23.1203 36.4434 22.8115 36.1346 22.8115 35.7549C22.8115 35.3752 23.1203 35.0664 23.5 35.0664C23.8797 35.0664 24.1885 35.3752 24.1885 35.7549C24.1885 36.1346 23.8797 36.4434 23.5 36.4434Z" fill="#0855C4")

                  .prepaid-process-step-3-item-content
                    p.px-3(v-if="typeOfDeposit=='banco'")
                      strong ¡Listo!
                      | Luego de realizar el depósito, te enviaremos un correo con el detalle de tu orden de prepago.
                    p.px-3(v-else)
                      strong ¡Listo!
                      | Luego de realizar el depósito, te enviaremos un correo con el detalle de tu orden de prepago.
              //.border-2-gray-light.mt-3.px-4.py-4
                v-layout.mt-3
                  v-flex(xs1)
                    .circle-blue
                      span 1
                  v-flex(xs11).pl-2
                    p(v-if="typeOfDeposit=='banco'") Dirígete al banco más cercano
                    p(v-if="typeOfDeposit=='transferencia'") Ingresa a tu app/banca por internet de alguno de estos bancos:
                    .g-flex.align-center.prepaid-process-step-3-list-img
                      figure.mt-3.mr-3
                        img(src='./../../assets/icons-prepagos/icon-interbank.png', alt='logo de interbank').max-width-100
                      figure.mt-3.mr-3
                        img(src="./../../assets/icons-prepagos/icon-bbva.png", alt="logo de BBVA", style="width: 43px;height: auto;").max-width-100
                      figure.mt-3.mr-3
                        img(src='./../../assets/icons-prepagos/icon-bcp.png', alt='logo de bcp').max-width-100
                      figure.mt-3
                        img(src='./../../assets/icons-prepagos/icon-scotiabank.png', alt='logo de scotiabank').max-width-100
                v-layout.mt-3
                  v-flex(xs1)
                    .circle-blue
                      span 2
                  v-flex(xs11).pl-2
                    p(v-if="typeOfDeposit=='banco'") Indica que realizarás el pago de póliza en MN (Moneda Nacional) o pago póliza ME (Moneda Extranjera)
                    p(v-if="typeOfDeposit=='transferencia'")
                      | Selecciona la opción&nbsp;
                      strong Pago de servicios&nbsp;
                      | luego escribe&nbsp;
                      strong Interseguro&nbsp;
                      | y selecciona la opción pago de póliza en MN (Moneda Nacional) o pago póliza ME (Moneda Extranjera)
                v-layout.mt-3
                  v-flex(xs1)
                    .circle-blue
                      span 3
                  v-flex(xs11).pl-2
                    p(v-if="typeOfDeposit=='banco'") Muestra tu número de póliza, el cual es el siguiente:
                    p(v-if="typeOfDeposit=='transferencia'") Ingresa tu número de póliza , el cual es el siguiente:
                v-layout
                  v-flex.text-xs-center
                    //- p.prepaid-process-step-3-text-number.mt-2 {{ codigoPrestamo }}
                    p.prepaid-process-step-3-text-number.mt-2 {{ numeroPoliza }}
                v-layout.mt-3.pb-4
                  v-flex(xs1)
                    .circle-blue
                      span 4
                  v-flex(xs11).pl-2
                    p(v-if="typeOfDeposit=='banco'") ¡Listo! Te enviaremos un correo con el detalle de tu orden de prepago.
                    p(v-if="typeOfDeposit=='transferencia'") ¡Listo! Confirma el monto y te enviaremos un correo cuando la transacción se haya realizado.
              v-layout.mt-4
                v-btn(@click="viewModal").btn-purple.px-4.mx-auto Generar orden de prepago
              .prepaid-process-step-3-message.mt-4
                figure.mr-1
                  img(src="./../../assets/iconsv5/icon-info-prepago.svg", alt="icono de info")
                p(v-if="typeOfDeposit=='banco'") Ten disposición de hacer el depósito dentro de las <strong>24 horas</strong>  después de generar la orden de prepago.
                p(v-else) Ten disposición de hacer el depósito dentro del mismo día de la generación del código de pago
    //- LOADER PROCESS
    v-dialog(v-model="validateLoader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | {{ textLoader }}
          v-progress-linear.mb-0(indeterminate="" color="white")
</template>
<script>
import prepaid from './../../interfaces/prepaid'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: ['numeroPoliza', 'codigoPrestamo'],
  data () {
    return {
      validateLoader: false,
      typeOfDeposit: 'banco',
      textLoader: '',
      nombreProducto: '',
      montoMinimoPrepago: '',
      currentDate: '',
      placeholderAmountPP: '',
      paramsPrepagos: {},
      general: {
        codigoPrestamo: '',
        saldoActualCapital: '',
        cuotasPendientes: '',
        montoCuotaActual: '',
        fechaInicioDePago: '',
        fechaFinDePago: ''
      },
      saldoInicial: null, // SALDO INICIAL EN EL PERIODO DE PRESTAMO SEGUN CUOTA APLICABLE
      fechaInicioPrestamo: null, // FECHA INICIO DE PRESTAMO QUE DEBE SER CALCULADO
      resultFirstRentas: {},
      resultFirstDevolucion: {},
      activeCircle1: true,
      activeCircle2: false,
      activeCircle3: false,
      dataTableLoad: [],
      cronograma: [{}],
      overlay: false,
      titleProcess: 'Conoce la deuda y simula tu prepago',
      step1Content: true,
      step2Content: false,
      step3Content: false,
      step1ShowColumnTwo: false,
      modalProcess: false,
      modalPrepaymentConditions: false,
      step2HeaderText: true,
      step2HeaderCheck: false,
      step3HeaderText: true,
      step3HeaderCheck: false,
      txtNumberLoad: null,
      resultMontoDevolucion: null,
      resultMontoRentas: null,
      dataInicialCalculos: null,
      hasSimulation: false,
      opcionBancoTransferencia: '',
      trackEvents: {
        simulator: {
          category: 'Prepagos',
          action: 'Acceso',
          label: 'Simulador de prepago',
          event: 'PREPAGO Simulado'
        },
        prepaidOrdered: {
          category: 'Prepagos',
          action: 'Acceso',
          label: 'Prepago orden generada',
          event: 'PREPAGO Orden generada'
        },
        error: {
          category: 'Prepagos',
          action: 'Error',
          label: 'Error de intento de prepago',
          event: 'PREPAGO Server Error orden'
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['getInformacionPrepagos', 'setIntencionPrepago', 'sendCronogramaPrepago']),
    ...mapActions('event', ['eventLog']),
    activeTableLoad (item) {
      this.dataTableLoad.forEach((v) => {
        v.active = false
        v.check = false
        v.inactive = true
      })
      item.active = true
      item.check = true
      item.inactive = false
    },
    makeQuote (montoPP) {
      let self = this
      self.$root.$emit('npsInactivity', {seccion: 'Prepagos - Primer paso - cotización', metadata: self.metadata})
      if (montoPP !== null && !isNaN(montoPP)) {
        this.dataTableLoad = []
        montoPP = parseFloat(montoPP.replace('S/', '').replace('$', '').replace(',', ''))
        let maxMontoPP = parseFloat(this.general.saldoActualCapital.replace('S/', '').replace('$', '').replace(',', ''))
        let minMontoPP = parseFloat((maxMontoPP * 0.1).toFixed(2))
        let currency = this.paramsPrepagos.moneda.nombre === 'SOLES' ? 'S/ ' : '$ '

        this.eventLog({
          categoria: 'Prepagos',
          nombre: 'Simulación de Prepago',
          datos: {
            monto: montoPP,
            montoMinimo: minMontoPP,
            montoMaximo: maxMontoPP,
            producto: self.nombreProducto,
            numeroPoliza: self.numeroPoliza,
            codigoPrestamo: self.codigoPrestamo,
            moneda: self.paramsPrepagos.moneda.nombre
          }
        })
        this.txtNumberLoad = currency + montoPP.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        if (montoPP > maxMontoPP) {
          self.step1ShowColumnTwo = false
          self.$swal({
            title: 'Estimado Cliente',
            text: 'Le comunicamos que máximo puede pre-pagar la deuda al día de hoy.',
            type: 'info',
            confirmButtonText: 'Entendido'
          })
        } else if (montoPP >= minMontoPP) {
          if (!self.hasSimulation) {
            self.hasSimulation = true
            self.trackEvents.simulator.producto = self.nombreProducto
            self.$gtm.trackEvent(self.trackEvents.simulator)
          }
          self.step1ShowColumnTwo = true
          let initial = {
            fechaPP: '',
            numeroCuotas: '',
            ingresoMensual: '',
            inicioPoliza: '',
            mesInicioPrestamo: '',
            tasaPrestamoAnual: '',
            saldoInicialPeriodo: '',
            montoPP: parseFloat(montoPP),
            cuotaPrestamo: '',
            devolucionFinal: '',
            periodoGarantizado: '',
            temporalidad: '',
            montoPrestamo: '',
            cuotaMaxima: '',
            periodoGracia: '',
            periodoGraciaExtraDiferido: '',
            periodosDiferidos: ''
          }
          // POBLANDO DATA INICIAL PARA EL CALCULO
          initial.fechaPP = new Date().toJSON().slice(0, 10)
          initial.numeroCuotas = this.paramsPrepagos.numeroCuotas
          initial.ingresoMensual = this.paramsPrepagos.ingresoMensual
          // QUITANDO EL HH:MM:SS
          // this.paramsPrepagos.fechaInicioPago = this.paramsPrepagos.fechaInicioPago.split('T')[0]
          // SETEANDO EL MOMENT
          let fechaInicioPago = moment(this.paramsPrepagos.fechaInicioPago)
          initial.fechaInicioPago = fechaInicioPago
          initial.inicioPoliza = fechaInicioPago.clone().subtract(this.paramsPrepagos.periodoDiferido, 'months')
          initial.mesInicioPrestamo = this.paramsPrepagos.cronograma[0].periodoPoliza
          initial.tasaPrestamoAnual = parseFloat(this.paramsPrepagos.tasaPrestamo) / 100
          initial.cronograma = this.paramsPrepagos.cronograma
          // OBTENCION DE LA INFORMACION DEL PERIODO ESTAMOS PIDIENDO EL PREPAGO
          // let infoCuotasAplicables = prepaid.getCuotaAplicable(initial)
          // BUSCANDOLO EN EL CRONOGRAMA LA CUOTA APLICABLE
          // let detalleCuotaAplicable = this.paramsPrepagos.cronograma[infoCuotasAplicables.cuotaAplicable - 1]
          let detalleCuotaAplicable = this.paramsPrepagos.cronograma
          initial.cronogramaCuotaAplicable = detalleCuotaAplicable
          // POBLANDO DATA FALTANTE
          initial.tasaPrestamoAnual = parseFloat(this.paramsPrepagos.tasaPrestamo) / 100
          initial.saldoInicialPeriodo = parseFloat(this.saldoInicial.replace(',', ''))
          initial.cuotaPrestamo = this.paramsPrepagos.montoCuota
          initial.devolucionFinal = parseFloat((this.paramsPrepagos.devolucionFinal + '').replace(',', ''))
          initial.periodoGarantizado = this.paramsPrepagos.periodoGarantizado
          initial.periodosDiferidos = this.paramsPrepagos.periodoDiferido
          initial.temporalidad = this.paramsPrepagos.periodoGarantizado
          initial.montoPrestamo = parseFloat(this.paramsPrepagos.montoPrestamo.replace('$', '').replace('S/', '').replace(',', ''))
          initial.cuotaMaxima = this.paramsPrepagos.ingresoMensual
          initial.periodoGraciaExtraDiferido = (this.paramsPrepagos.periodoDiferido - (initial.mesInicioPrestamo - 1)) < 0 ? 0 : this.paramsPrepagos.periodoDiferido - (initial.mesInicioPrestamo - 1)
          initial.periodoGracia = initial.periodoGraciaExtraDiferido
          initial.fechaInicioPrestamo = this.fechaInicioPrestamo
          // EJECUTANDO CALCULOS
          prepaid.setInfoDataPrepaid(initial)
          self.resultMontoDevolucion = prepaid.getInputsMontoPrimeroDevolucion(initial)
          self.dataInicialCalculos = initial
          // this.resultMontoRentas = prepaid.getInputsMontoPrimeroRentas(initial)
          self.resultPlazoDevolucion = prepaid.getInputsPlazoPrimeroDevolucion(initial, this.resultMontoDevolucion)
          // SI el pago no cubre toda la devolución consumida por el préstamo anterior se le suma +1 por el prepago y +1 por el monto de devolucion
          // SI el pago cubre toda la devolución consumida por el préstamo anterior solo se le suma +1 por el prepago
          // eslint-disable-next-line no-unused-vars
          let cantidadCuotasAfectasMonto = this.resultMontoDevolucion.vfPrestamoAdicional > 0 ? this.resultMontoDevolucion.cuotasRestantes + 2 : this.resultMontoDevolucion.cuotasRestantes + 1
          // [JTRAC-PPRISD-36] -> Mostrar las cuotas restantes enves de mostrar las cuotas reales de un prepago.
          // [MOTIVO] -> Es incomodo para el cliente ver +1 o +2 cuotas más. QA persiste en este punto.
          let resultMonto = {
            id: 1,
            activeBackBlue: true,
            activeBackGray: false,
            activeCuota: false,
            activeMonto: true,
            active: false,
            check: false,
            inactive: true,
            option: 'A',
            name: '<p class="white--text">Reduce el <strong style="text-decoration:underline">monto</strong> de la cuota</p>',
            type: 'Reduce el monto de la cuota',
            moneyCout: this.resultPlazoDevolucion.cuotaMin > 0 ? currency + ((this.resultMontoDevolucion.cuota2 * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : currency + '0.00',
            numberCout: this.resultMontoDevolucion.cuotasRestantes === 0 ? 1 : this.resultMontoDevolucion.cuotasRestantes,
            numberCapital: currency + this.resultMontoDevolucion.devolucionFinal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          }
          self.dataTableLoad.push(resultMonto)
          let resultPlazo = {
            id: 2,
            activeBackBlue: true,
            activeBackGray: false,
            activeCuota: false,
            activeMonto: true,
            active: false,
            check: false,
            inactive: true,
            option: 'B',
            name: '<p class="white--text">Reduce el <strong style="text-decoration:underline">número</strong> de cuotas pendientes</p>',
            type: 'Reduce el número de cuotas pendientes',
            moneyCout: this.resultPlazoDevolucion.cuotaMin > 0 ? currency + ((initial.cuotaPrestamo * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : currency + '0.00',
            numberCout: (this.resultPlazoDevolucion.cuotaMin + this.resultPlazoDevolucion.periodoGraciaSinCuota === 0) ? 1 : this.resultPlazoDevolucion.cuotaMin + this.resultPlazoDevolucion.periodoGraciaSinCuota + 1,
            numberCapital: currency + this.resultMontoDevolucion.devolucionFinal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          }
          self.dataTableLoad.push(resultPlazo)
        } else {
          self.step1ShowColumnTwo = false
          self.$swal({
            title: 'Estimado Cliente',
            text: 'Le comunicamos que el minimo monto a prepagar es el 10% de su Deuda al día de hoy. Favor de revisar el monto puesto.',
            type: 'info',
            confirmButtonText: 'Entendido'
          })
        }
      }
    },
    clearAmountField () {
      this.txtNumberLoad = null
    },
    goToHome () {
      const self = this
      this.$router.push({ name: 'Home' }).then(() => {
        self.$root.$emit('showNps', {nombre: 'NPS - Inicio de Encuesta', funcionalidad: 'Intención de Prepago', metadata: self.metadata})
      }).catch(() => {
        self.$root.$emit('showNps', {nombre: 'NPS - Inicio de Encuesta', funcionalidad: 'Intención de Prepago', metadata: self.metadata})
      })
    },
    hasAnotherSimulation () {
      this.clearAmountField()
      this.step1ShowColumnTwo = false
    },
    verifyChars (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if (!(/^[0-9]*\.?[0-9]*$/).test(evt.key) && charCode !== 8) {
        evt.preventDefault()
      }
      if (this.txtNumberLoad !== null) {
        if (this.txtNumberLoad.indexOf('.') > -1 && this.txtNumberLoad.substring(this.txtNumberLoad.indexOf('.')).length > 2) {
          evt.preventDefault()
        }
      }
    },
    viewModal () {
      let self = this
      this.validateLoader = true
      this.textLoader = 'Procesando su prepago...'
      let codigoPrepago = (Math.floor(Math.random() * 900000) + 100000) + ''
      let currency = this.paramsPrepagos.moneda.nombre === 'SOLES' ? 'S/ ' : '$ '
      // SETEANDO VALORES PARA LA INTENCION DE PREPAGO EN ADMWR
      let electionChoseen = this.dataTableLoad.filter((v) => { return v.active === true })
      let codigoTipoReduccion = electionChoseen[0].id
      if (codigoTipoReduccion === 1) {
        self.cronograma = prepaid.makeCronoPrimeroDevolucionMonto(this.dataInicialCalculos, this.resultMontoDevolucion)
        let cantidadCuotasAfectasMonto = this.resultMontoDevolucion.vfPrestamoAdicional > 0 ? this.resultMontoDevolucion.cuotasRestantes + 2 : this.resultMontoDevolucion.cuotasRestantes + 1
        self.cronograma[0].numeroNumCuotas = cantidadCuotasAfectasMonto
      } else {
        self.cronograma = prepaid.makeCronoPrimeroDevolucionPlazo(this.dataInicialCalculos, this.resultMontoDevolucion, this.resultPlazoDevolucion)
        self.cronograma[0].numeroNumCuotas = this.resultPlazoDevolucion.cuotaMin + this.resultPlazoDevolucion.periodoGraciaSinCuota + 1
      }
      this.cronograma[0].codigoUsuario = this.userInfo.codigoUsuario
      this.cronograma[0].codigoTipoReduccion = codigoTipoReduccion
      this.cronograma[0].nombreCliente = this.paramsPrepagos.nombreCliente
      this.cronograma[0].producto = this.paramsPrepagos.tipoProducto
      this.cronograma[0].numeroPoliza = this.paramsPrepagos.numeroPoliza
      this.cronograma[0].numeroDocumento = this.basicInfo.numeroDocumento
      this.cronograma[0].montoPrepago = this.txtNumberLoad
      this.cronograma[0].montoCuota = currency + ((this.resultMontoDevolucion.cuota2 * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      this.cronograma[0].codigoPrestamo = this.paramsPrepagos.codigoPrestamo
      this.cronograma[0].codigoPrepago = codigoPrepago
      this.cronograma[0].tasa = this.paramsPrepagos.tasaPrestamo
      this.cronograma[0].devolucion = currency + this.resultMontoDevolucion.devolucionFinal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      this.cronograma[0].inicioPago = this.general.fechaInicioDePago
      this.cronograma[0].finPago = this.general.fechaFinDePago
      this.cronograma[0].sendMail = 'true'
      // SETEAS LA INTENCION Y LUEGO MANDAS EL CRONOGRAMA A LA ZONA PRIVADA
      this.sendCronogramaPrepago(this.cronograma)
        .then((res) => {
          self.modalProcess = true
          self.trackEvents.prepaidOrdered.producto = self.nombreProducto
          self.trackEvents.prepaidOrdered.tipoPrepago = (codigoTipoReduccion === 1) ? 'Reduce el monto de la cuota' : 'Reduce el número de cuotas'
          self.trackEvents.prepaidOrdered.metodoPago = self.opcionBancoTransferencia
          self.$gtm.trackEvent(self.trackEvents.prepaidOrdered)
        })
        .catch((err) => {
          self.trackEvents.error.producto = self.nombreProducto
          self.trackEvents.error.tipoPrepago = (codigoTipoReduccion === 1) ? 'Reduce el monto de la cuota' : 'Reduce el número de cuotas'
          self.trackEvents.error.metodoPago = self.opcionBancoTransferencia
          self.$gtm.trackEvent(self.trackEvents.error)
          self.$swal({
            title: 'Estimado Cliente',
            text: 'Tenemos un inconveniente al procesar su prepago. Inténtelo en unos minutos después.',
            type: 'info',
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.$root.$emit('showNps', {nombre: 'NPS - Inicio de Encuesta', funcionalidad: 'Intención de Prepago', metadata: { ...self.metadata, error: err }})
          })
        })
    },
    viewStep2 () {
      const self = this
      let electionChoseen = this.dataTableLoad.filter((v) => { return v.active === true })
      if (electionChoseen.length > 0) {
        this.titleProcess = '¿Cómo quieres pagar?'
        this.step1Content = false
        this.step2Content = true
        this.activeCircle2 = true
        this.step2HeaderText = false
        this.step2HeaderCheck = true
        self.eventLog({
          categoria: 'Prepagos',
          nombre: 'Confirmación de Simulación',
          datos: {
            producto: self.nombreProducto,
            numeroPoliza: self.numeroPoliza,
            codigoPrestamo: self.codigoPrestamo,
            moneda: self.paramsPrepagos.moneda.nombre,
            Tipo: electionChoseen[0].type
          }
        })
        self.$root.$emit('npsInactivity', {seccion: 'Prepagos - Segundo paso', metadata: self.metadata})
      }
    },
    viewStep3 (opcion) {
      const self = this
      self.eventLog({
        categoria: 'Prepagos',
        nombre: 'Intención de Prepago',
        datos: {
          producto: self.nombreProducto,
          numeroPoliza: self.numeroPoliza,
          codigoPrestamo: self.codigoPrestamo,
          moneda: self.paramsPrepagos.moneda.nombre,
          Tipo: opcion
        }
      })
      self.$root.$emit('npsInactivity', {seccion: 'Prepagos - Tercer paso', metadata: self.metadata})
      this.opcionBancoTransferencia = opcion
      this.typeOfDeposit = opcion
      this.titleProcess = 'Sigue los siguientes pasos para realizar el abono'
      this.step2Content = false
      this.step3Content = true
      this.activeCircle3 = true
      this.step3HeaderText = false
      this.step3HeaderCheck = true
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'basicInfo', 'userInfo', 'functionsRules'])
  },
  mounted () {
    let self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PREPAGOS, self.functionsRules, self)) {
      self.$router.push('/inicio')
      return
    }
    self.validateLoader = true
    self.textLoader = 'Validando información...'
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    self.currentDate = dd + '/' + mm + '/' + yyyy
    self.getInformacionPrepagos({ numeroPoliza: self.numeroPoliza, codigoPrestamo: self.codigoPrestamo })
      .then((res) => {
        self.paramsPrepagos = res.data
        self.metadata = {
          numeroPoliza: self.numeroPoliza,
          productoConsultado: 'RRVV',
          subproductoConsultado: res.data.tipoProducto
        }
        self.$root.$emit('npsInactivity', {seccion: 'Prepagos - Primer paso', metadata: self.metadata})
        self.nombreProducto = res.data.tipoProducto === 'RPP' ? 'Renta Particular Plus' : 'Ingreso Seguro con Devolución'
        let initial = {
          fechaPP: '',
          numeroCuotas: '',
          inicioPoliza: '',
          mesInicioPrestamo: '',
          tasaPrestamoAnual: '',
          periodoGarantizado: '',
          periodosDiferidos: ''
        }
        // POBLANDO DATA INICIAL PARA EL CALCULO
        initial.fechaPP = yyyy + '-' + mm + '-' + dd
        // QUITANDO EL HH:MM:SS
        self.paramsPrepagos.fechaInicioPago = self.paramsPrepagos.fechaInicioPago.split('T')[0]
        let fechaInicioPago = moment(self.paramsPrepagos.fechaInicioPago)
        initial.fechaInicioPago = fechaInicioPago
        initial.numeroCuotas = self.paramsPrepagos.numeroCuotas
        initial.inicioPoliza = fechaInicioPago.clone().subtract(self.paramsPrepagos.periodoDiferido, 'months')
        initial.mesInicioPrestamo = self.paramsPrepagos.cronograma[0].periodoPoliza
        initial.tasaPrestamoAnual = parseFloat(self.paramsPrepagos.tasaPrestamo) / 100
        initial.periodoGarantizado = self.paramsPrepagos.periodoGarantizado
        initial.periodosDiferidos = self.paramsPrepagos.periodoDiferido
        initial.ingresoMensual = self.paramsPrepagos.ingresoMensual + self.paramsPrepagos.montoCuota
        initial.cronograma = self.paramsPrepagos.cronograma
        initial.montoPrestamo = parseFloat(self.paramsPrepagos.montoPrestamo.replace('$', '').replace('S/', '').replace(',', ''))
        // CALCULO DE MONTOS PRESTAMOS PARA CALCULOS VENIDEROS
        // eslint-disable-next-line no-unused-vars
        let calculosPrestamos = prepaid.calculateInfoPrestamo(initial)
        // OBTENCION DE LA INFORMACION DEL PERIODO ESTAMOS PIDIENDO EL PREPAGO
        let infoCuotasAplicables = prepaid.getCuotaAplicable(initial)
        // SETEANDO DATOS GENERALES
        let currency = self.paramsPrepagos.moneda.nombre === 'SOLES' ? 'S/ ' : '$ '
        let cuotaCronogramaAplicable = infoCuotasAplicables.cuotaAplicable < 1 ? 0 : infoCuotasAplicables.cuotaAplicable - 1
        self.saldoInicial = self.paramsPrepagos.cronograma[cuotaCronogramaAplicable].saldoInicial
        self.fechaInicioPrestamo = infoCuotasAplicables.fechaInicioPrestamo
        self.placeholderAmountPP = currency + '0.0'
        self.general.saldoActualCapital = currency + infoCuotasAplicables.prepagoMax.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        self.montoMinimoPrepago = currency + (((infoCuotasAplicables.prepagoMax * 0.1) * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        self.general.cuotasPendientes = infoCuotasAplicables.cuotasRestantes
        self.general.montoCuotaActual = currency + ((self.paramsPrepagos.montoCuota * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        if (fechaInicioPago.isSameOrAfter(infoCuotasAplicables.fechaInicioPrestamo)) {
          self.general.fechaInicioDePago = fechaInicioPago.locale('es').format('MMMM YYYY')
        } else {
          self.general.fechaInicioDePago = infoCuotasAplicables.fechaInicioPrestamo.locale('es').format('MMMM YYYY')
        }
        self.general.fechaFinDePago = self.paramsPrepagos.fechaFinPago
        self.validateLoader = false
      })
  }
}
</script>

<style>
  @import url('../../assets/css/general.css');
  .btn-entendido {
    width: 200px!important;
  }
  .prepaid-process {
    font-family: "Omnes Regular", sans-serif;
  }
  .prepaid-process p {
    margin-bottom: 0;
  }
  .prepaid-process p,
  .prepaid-process h2 {
    font-size: 14px;
    color: var(--text-color);
  }
  .prepaid-process h3 {
    font-size: 18px;
  }

  .prepaid-process-step-2 article {
    border-radius: 5px;
    max-width: 400px;
  }

  .prepaid-process-step-3 article {
    border-radius: 5px;
    max-width: 400px;
  }
  .prepaid-process-step-3-list article {
    border: 1px dashed #C4C4C4;
    box-sizing: border-box;
    border-radius: 5px;
    height: 247px;
    margin: 20px auto 0 auto;
    width: 197px;
  }
  .prepaid-process-step-3-list article:nth-of-type(2) p:nth-of-type(2) {
    color: #0855C4;
    font-size: 11.5px;
    margin: 5px 0 0 10px;
  }
  .prepaid-process-step-3-list article:nth-of-type(3) .prepaid-process-step-3-text-number {
    font-size: 18px;
  }
  .prepaid-process-step-3-item-title {
    height: 105px;
    margin-top: 10px;
    text-align: center;
  }
  .prepaid-process-step-3-item-title .circle-blue {
    margin-bottom: 15px;
  }
  .prepaid-process-step-3-item-title .circle-blue span {
    font-size: 17.44px;
  }
  .prepaid-process-step-3-item-content p:nth-of-type(1) {
    text-align: justify;
  }
  .prepaid-process-step-3-list-img img {
    height: 20px;
  }
  .prepaid-process-step-3-text-number {
    background: #f2f2f2;
    display: inline-block;
    font-weight: bold;
    padding: 4px 10px;
  }
  .prepaid-process-one-row-icon figure {
    width:37px;
  }
  .prepaid-process-one-row-icon p {
    margin-top:-2px;
  }
  .prepaid-process-one-date p::first-letter {
    text-transform: uppercase;
  }
  .prepaid-process-one-date .g-flex {
    font-weight: bold;
    justify-content: space-between;
  }
  .modal-prepayment-conditions h3 {
    font-size: 18px;
    margin-bottom: 15px;
  }
  .modal-prepayment-conditions p {
    font-size: 16px;
    line-height: 21px;
  }
  .modal-prepayment-conditions ul {
    list-style-type: none;
    padding-left: 10px;
  }
  .modal-prepayment-conditions li ul {
    padding-left: 15px!important;
  }
  .modal-prepayment-conditions li {
    margin-top: 7px;
  }
  .modal-process-circle {
    align-items: center;
    border: 2px solid rgb(8, 85, 196);
    border-radius: 50%;
    display: flex;
    height: 23px;
    justify-content: center;
    margin:auto;
    width: 23px;
  }
  .modal-process-circle i {
    color: rgb(8, 85, 196)!important;
    font-weight: bold;
    font-size: 1rem;
  }
  .modal-process-rect {
    border: 2px solid rgb(8, 85, 196);
    background: rgba(8, 85, 196, 0.1);
  }
  .modal-process h2 {
    color: #0855C4;
    font-size: 19px;
    margin-bottom: 15px;
  }
  .modal-process a {
    text-decoration: underline;
  }
  .modal-process-rect p {
    font-size: 16px;
  }
  .text-semiblue p {
    color: var(--text-color) !important;
  }
  .prepaid-process-header .layout {
    justify-content: space-between;
    margin: 0 auto 20px auto;
    max-width: 200px;
  }
  .prepaid-process-header .circle {
    align-items: center;
    border:2px solid rgb(8, 85, 196);
    border-radius: 50%;
    display: flex;
    height: 30px;
    justify-content: center;
    position: relative;
    width: 30px;
  }
  .circle-active {
    background: rgb(8, 85, 196)!important;
  }
  .circle-active i {
    color: white!important;
  }
  .circle-line::before{
    background: rgb(8, 85, 196);
    content:'';
    height: 2px;
    top: 50%;
    left:28px;
    transform: translateY(-50%);
    position: absolute;
    width: 56px;
  }
  .prepaid-process-header .circle p{
    color:rgb(8, 85, 196);
    font-weight: bold;
  }
  .prepaid-process-header .circle i{
    color:rgb(8, 85, 196);
    font-weight: bold;
    font-size: 1.2rem;
  }
  .prepaid-process-step-2 i{
    color:rgb(8, 85, 196)!important;
    font-size: 2.2rem;
  }
  .prepaid-process-step-2-remenber{
    background: #EEF3FB;
    height: 65px;
    margin: 30px auto 0 auto;
    padding: 13px 0 0 18px;
    width: 441px;
  }
  .prepaid-process-step-2-remenber p{
    font-size: 18px;
    line-height: 19.5px;
    margin-bottom: 0px!important;
    margin-left: 7px;
    max-width: 382px;
  }
  .prepaid-process-step-3-message{
    background: #EEF3FB;
    display: flex;
    padding: 10px 20px;
    margin-left: auto;
    margin-right: auto;
    max-width: 441px;
  }
  .prepaid-process-step-3-message figure{
    margin-top: 4px;
  }
  .prepaid-process-step-3-message figure img{
    width: 15px;
  }
  .prepaid-process-step-3-message p{
    font-size: 15px !important;
  }
  .text-sky {
    color: #2CBBF1 !important;
    font-size: 10px !important;
  }

  @media screen and (max-width: 959px){
    .prepaid-process-header{
      margin-top: 45px;
    }
    .prepaid-process-one-date span{
      display: none;
    }
  }

  @media screen and (max-width: 991px){
    .prepaid-process-two{
      margin-top:25px!important;
    }
    .prepaid-process-two .style-table-circle{
      display: none;
    }
    .prepaid-process-main-item{
      margin-left: auto;
      margin-right: auto;
      max-width: 450px;
    }
    .prepaid-process-one-date{
      display: flex;
    }
    .prepaid-process-one-date .g-flex p:nth-of-type(2){
      margin-left: 5px;
    }
    .prepaid-process-one-date .g-flex:nth-of-type(2){
      margin-left: 15px;
    }
    .prepaid-process-two-row {
      flex-direction: column;
    }
  }
  @media screen and (min-width: 960px){
    .prepaid-process-one-date{
      align-items: center;
      display: flex;
    }
    .prepaid-process-one-date .g-flex{
      width: 45%;
    }
    .prepaid-process-one-date span{
      text-align: center;
      margin-right: 5%;
      width: 5%;
    }
  }
  @media screen and (min-width: 992px){
    .prepaid-process-one article{
      width: 90%;
    }
    .prepaid-process-two article{
      width: 88%;
    }
    .prepaid-process-two article{
      margin-left: auto;
      margin-right: 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/Prepaids/Process.vue